/** Continuum's brand mark, rendered from the actual logo assets in `public/`
 * rather than recreated in code, so it always matches the source files
 * exactly. `LogoMark` is the icon alone (colour wheel, no wordmark) for
 * spots too small for the full lockup. */
export function LogoMark({ className = "" }) {
  return (
    <img
      src="/continuum-logo-icon.png"
      alt=""
      aria-hidden="true"
      className={`object-contain ${className}`}
    />
  );
}

export default function Logo({ dark = false, className = "" }) {
  return (
    <span
      data-testid="brand-logo"
      className={`inline-flex items-center ${dark ? "bg-white rounded-sm px-2.5 py-1.5" : ""} ${className}`}
    >
      <img src="/continuum-logo.png" alt="Continuum" className="h-7 w-auto block" />
    </span>
  );
}
